import { Box, ButtonBase } from '@mui/material';
import { Notification } from '@zaplify/ui';
import { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

import { paths } from '../../routes/paths';

export const ProspectingView = () => {
    const newSearchUi = true;
    const { pathname } = useLocation();
    const [notifcation, setNotification] = useState<{
        text: string;
        severity: 'success' | 'error' | 'info' | 'warning';
    }>({ text: '', severity: 'success' });

    return (
        <Box
            sx={{
                gap: '16px',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                position: 'relative',
                fontFamily:
                    '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu","Cantarell", "Fira Sans", "Droid Sans", sans-serif !important',
            }}
        >
            <Box sx={{ gap: '16px', display: 'flex', flexDirection: 'column' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '16px',
                        '& button': {
                            fontFamily:
                                '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu","Cantarell", "Fira Sans", "Droid Sans", sans-serif !important',
                            display: 'flex',
                            height: '32px',
                            padding: '4px 0px',
                            alignItems: 'center',
                            gap: 'var(--S-s-regular, 8px)',
                            borderBottom: '2px solid transparent',
                            fontWeight: 500,
                            fontSize: '15px',
                            transition: '200ms',
                            '&.active': {
                                borderBottom: '2px solid var(--grey-palette-grey-6, #3A4B59)',
                                color: '#3A4B59',
                            },
                            '&.inactive': {
                                color: 'var(--grey-palette-grey-4, #969FAC)',
                                '&:hover': {
                                    color: '#3A4B59',
                                },
                            },
                        },
                    }}
                >
                    <Link to={paths.SEARCH} style={{ textDecoration: 'none' }}>
                        <ButtonBase className={pathname.includes('search') ? 'active' : 'inactive'}>
                            Filter search
                        </ButtonBase>
                    </Link>

                    <Link to={paths.IMPORT_CSV_PROSPECTS} style={{ textDecoration: 'none' }}>
                        <ButtonBase className={pathname.includes('import-prospects') ? 'active' : 'inactive'}>
                            List import
                        </ButtonBase>
                    </Link>
                </Box>
            </Box>
            <Outlet />
            {Boolean(notifcation.text) && (
                <Notification
                    open={Boolean(notifcation.text)}
                    onClose={() => setNotification({ ...notifcation, text: '' })}
                    text={notifcation.text}
                    severity={notifcation.severity}
                />
            )}
        </Box>
    );
};
